import { useEffect, useRef } from "react";
import { useLocation } from "@tanstack/react-router";

import { mark, startTimer, type PerfTimer } from "@/lib/perf";

let navTimer: PerfTimer | null = null;
let lastKnownPath: string | null = null;

export function markContentVisible(cached: boolean) {
  navTimer?.stop({ cached });
  navTimer = null;
}

/**
 * Call after `window.history.replaceState` so the nav tracker knows the
 * current path without waiting for the router location update.
 */
export function syncNavPath(path: string) {
  lastKnownPath = path;
}

export function useNavPerf() {
  const location = useLocation();
  const pathname = location.pathname;
  const prevRef = useRef(pathname);

  useEffect(() => {
    const effectivePrev = lastKnownPath ?? prevRef.current;
    if (pathname !== effectivePrev) {
      prevRef.current = pathname;
      lastKnownPath = null;
      mark("nav.route_change", { to: pathname });
      navTimer = startTimer("nav.content_visible");
    } else {
      prevRef.current = pathname;
      lastKnownPath = null;
    }
  }, [pathname]);
}
